module.exports = __webpack_public_path__ + "static/media/datetime.0cd3ba6f.png";